import {
  DOWNLOAD_MANAGER_CANCEL_ERROR_NAME,
  DOWNLOAD_MANAGER_DEFAULT_ERROR_NAME,
} from "./constants";

export enum CommandName {
  DOWNLOAD = "download",
  CANCEL_DOWNLOAD = "cancelDownload",
  DISPOSE = "dispose",
  TERMINATE_ALL_DOWNLOADS = "terminateAllDownloads",
}

export enum DownloadCommandCallbackName {
  PROGRESS = "progress",
  COMPLETED = "completed",
}

export type Command = {
  name: CommandName;
};

export type DownloadCommand = Command & {
  downloadId: string;
  urls: Array<string>;
  priority: number;
  shouldReportProgress: boolean;
};

export type CancelDownloadCommand = Command & {
  downloadId: string;
};

export type DisposeCommand = Command & {
  url: string;
};

export type DownloadCommandCallback = {
  name: DownloadCommandCallbackName;
  downloadId: string;
};

export type CompletedDownloadCommandCallback = DownloadCommandCallback & {
  items: Array<{
    url: string;
    error?: DownloadManagerError;
    result?: {
      downloadedUrl: string;
      size: number;
    };
  }>;
};

export type ProgressDownloadCommandCallback = DownloadCommandCallback & {
  progress: number;
};

export type Download = {
  downloadId: string;
  items: Map<string, DownloadItem>;
  shouldReportProgress: boolean;
  isCanceled: boolean;
};

export type DownloadItem = {
  taskId: string;
  url: string;
  error?: DownloadManagerError;
  result?: {
    downloadedUrl: string;
    size: number;
  };
  isCompleted: boolean;
};

export type DownloadTask = {
  id: string;
  downloadId: string;
  url: string;
  priority: number;
  isStarted: boolean;
  isCanceled: boolean;
};

export type FetchResult = { url: string; size: number };

export type FetchInfo = {
  promise: Promise<FetchResult>;
  abortController: AbortController;
  url: string;
};

export enum DownloadManagerErrorName {
  DEFAULT = DOWNLOAD_MANAGER_DEFAULT_ERROR_NAME,
  CANCEL = DOWNLOAD_MANAGER_CANCEL_ERROR_NAME,
}

export type DownloadManagerError = {
  name: DownloadManagerErrorName;
};
